export const Accordion = {
  baseStyle: {
    container: {
      borderWidth: '0px',
      marginTop: '0px',
      marginBottom: '8px',
      _last: {
        borderBottomWidth: 0,
      },
    },
    panel: {
      padding: '2px',
      minHeight: '120px',
    },
    button: {
      padding: '16px',
      bg: 'neutral.50',
      borderRadius: '16px',
      borderWidth: '1px',
      borderColor: 'neutral.300',
      marginBottom: '0px',
    },
  },
};
